import { Reducer } from 'interfaces'
import { AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { createFetchableReducer, createEmptyFetchable } from 'helpers/loadableHelpers'
import { CANCEL_ADVISOR_MEETING, ResetCancelMeetingAction } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { KILL_FLOATING_PANES, KILL_ALL_FLOATING_PANES } from 'actions/floatingPanesActions'


const fetchableRequestReducer = createFetchableReducer<null>()
export const cancelMeetingReducer: Reducer<AdvisorDataState['cancelMeetingRequest']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case CANCEL_ADVISOR_MEETING:
      return fetchableRequestReducer(prevState, action)

    case KILL_ALL_FLOATING_PANES:
    case KILL_FLOATING_PANES:
    case ResetCancelMeetingAction.type:
      if (prevState.errorCode || prevState.errorsMap) {
        return createEmptyFetchable()

      }
      return prevState
  }
  return prevState
}
